import { ComponentPropsWithoutRef, forwardRef } from 'react';

type Props = ComponentPropsWithoutRef<'div'>;

const LNBMenu = forwardRef<HTMLDivElement, Props>(({ children, ...props }, ref) => {
  return (
    <div {...props} ref={ref} className="cont_snb">
      <ul className="list_snb">{children}</ul>
    </div>
  );
});

LNBMenu.displayName = 'LNBMenu';

export default LNBMenu;
